<table>
  <thead>
  <th>Name</th>
  <th>Link</th>
  <th>Image</th>
  <th>Description</th>
  </thead>
  <tbody>
  <tr *ngFor="let item of theItems | async">
    <td>{{item.name}}</td>
    <td>{{item.webReference}}</td>
    <td>{{item.iconURL}}</td>
    <td>{{item.description}}</td>
    <td>
      <button (click)="delete(item.id)">Delete</button>
    </td>
  </tr>
  </tbody>
</table>`
